import React, { useEffect } from "react";

import { IoIosArrowForward } from "react-icons/io";

import { serviceimage } from "../../../Assets/images/ImagesIndex";
import { allServices, setAllservices } from "../../../Redux/Slices/Pages/services/servicesSlice";
import { useDispatch, useSelector } from "react-redux";
import Workercard from "../../../Components/Card/WorkerCard/Workercard";



const Services = () => {
  const dispatch = useDispatch();
  const serviceInfo = useSelector((state) => state.services.allServices);

  useEffect(()=>{
    dispatch(allServices());
    return(()=>{
      dispatch(setAllservices([]));
    })
  },[]);

  return (
    <div className="flex flex-col gap-3  w-full rounde ">

      <div className=" w-full grid grid-cols-3 sm:grid-cols-2 md:grid-cols-3 mt-3 gap-5 ">
        {serviceInfo.map((serv) => (
          <Workercard key={serv._id} workerData={serv} />
        ))}
      </div>
      {/* <div className=" bg-white  w-full ">
        <div className="flex gap-5  p-2 ">
          <h1 className="font-semibold">Cleaning service</h1>

          <button className="flex items-center gap-1 mr-4  p-1 bg-slate-100 text-sm rounded-lg border border-black-100">
            See All
            <IoIosArrowForward />
          </button>
        </div>
        <div className="service-container w-full  flex gap-4  p-4 grid grid-cols-1 md:grid-cols-6 ">
          <img className="" src={serviceimage} alt="" />
          <img className="" src={serviceimage} alt="" />
           <img className="" src={serviceimage} alt="" />
          <img className="" src={serviceimage} alt="" />
           <img className="" src={serviceimage} alt="" />
          <img className="" src={serviceimage} alt="" />
        </div>
      </div> */}
      {/* <div className=" bg-white rounded-lg m-2 ">
        <div className="flex gap-5 m-5 p-2">
          <h1 className="font-semibold">Vehicle service</h1>

          <button className="flex items-center gap-1 mr-4  p-1 bg-slate-100 text-sm rounded-lg border border-black-100">
            See All
            <IoIosArrowForward />
          </button>
        </div>
        <div className="service-container w-full  flex gap-4 m-4 p-4">
          <img className="" src={serviceimage} alt="" />
          <img className="" src={serviceimage} alt="" />
        </div>
      </div> */}
    </div>
  );
};

export default Services;
